(function () {
  const API_URL = "https://cs.creviatech.com/v1/chat/completions";
  const API_KEY = "crave_ai_service";

  function shouldHideChat() {
    const path = window.location.pathname.toLowerCase();
    const href = window.location.href.toLowerCase();

    return (
      path.includes("/cart") ||
      path.includes("/checkout") ||
      href.includes("checkout")
    );
  }

  const SESSION_ID = crypto.randomUUID ? crypto.randomUUID() : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });

  const CHAT_TITLE = "AI Support";
  const GREETING_TITLE = "Luna";
  const GREETING_TEXT = `Hi, I'm Luna, your shopping assistant.\nI'm here to help you explore products, answer common questions, and make your shopping experience easier.`;
  const DISCLAIMER_TEXT = `AI-generated replies may occasionally be inaccurate. Please refer to the official site information when needed.`;

  const SUGGESTED_QUESTIONS = [
    "I'm new here. Which product should I start with?",
    "How discreet is the packaging?",
    "How long does shipping usually take?",
    "How do I clean it? Is it waterproof?"
  ];

  function createChatUI() {
    if (shouldHideChat()) return;

    const wrap = document.createElement("div");
    wrap.id = "zb-chat-wrap";
    wrap.innerHTML = `
      <button id="zb-chat-btn" aria-label="Open chat">Chat</button>

      <div id="zb-chat-box" style="display:none;">
        <div id="zb-chat-header">
          <span>${CHAT_TITLE}</span>
          <button id="zb-chat-close" aria-label="Close chat">×</button>
        </div>

        <div id="zb-chat-messages"></div>

        <div id="zb-chat-input-row">
          <input id="zb-chat-input" type="text" placeholder="Type your question..." />
          <button id="zb-chat-send">Send</button>
        </div>
      </div>
    `;
    document.body.appendChild(wrap);

    const style = document.createElement("style");
    style.innerHTML = `
      #zb-chat-wrap{
        position:fixed;
        right:20px;
        bottom:20px;
        z-index:9999;
        font-family:Arial,sans-serif;
        pointer-events:none;
      }

      #zb-chat-btn,
      #zb-chat-box{
        pointer-events:auto;
      }

      #zb-chat-btn{
        background:#fff;
        color:#111;
        padding:12px 16px;
        border:1px solid #ddd;
        border-radius:999px;
        cursor:pointer;
        box-shadow:0 4px 12px rgba(0,0,0,.2);
        font-size:14px;
        font-weight:700;
      }

      #zb-chat-box{
        width:360px;
        height:560px;
        background:#fff;
        border:1px solid #ddd;
        border-radius:20px;
        box-shadow:0 10px 30px rgba(0,0,0,.18);
        overflow:hidden;
        margin-top:12px;
        display:flex;
        flex-direction:column;
      }

      #zb-chat-header{
        background:#111;
        color:#fff;
        padding:14px 16px;
        font-weight:700;
        display:flex;
        align-items:center;
        justify-content:space-between;
        font-size:15px;
      }

      #zb-chat-close{
        background:transparent;
        border:none;
        color:#fff;
        font-size:24px;
        line-height:1;
        cursor:pointer;
      }

      #zb-chat-messages{
        flex:1;
        overflow:auto;
        padding:14px;
        background:#fafafa;
      }

      #zb-chat-input-row{
        display:flex;
        gap:8px;
        padding:12px;
        border-top:1px solid #eee;
        background:#fff;
      }

      #zb-chat-input{
        flex:1;
        padding:10px 12px;
        border:1px solid #ddd;
        border-radius:12px;
        outline:none;
        font-size:14px;
      }

      #zb-chat-send{
        padding:10px 14px;
        border:none;
        background:#111;
        color:#fff;
        border-radius:12px;
        cursor:pointer;
        font-size:14px;
        font-weight:700;
      }

      .zb-msg{
        margin:8px 0;
        padding:10px 12px;
        border-radius:14px;
        max-width:85%;
        line-height:1.5;
        font-size:14px;
        white-space:pre-wrap;
        word-break:break-word;
      }

      .zb-user{
        background:#111;
        color:#fff;
        margin-left:auto;
      }

      .zb-ai{
        background:#fff;
        color:#111;
        border:1px solid #e8e8e8;
      }

      .zb-intro-card{
        background:linear-gradient(135deg,#7a1fa2 0%, #e040fb 100%);
        color:#fff;
        border-radius:18px;
        padding:14px;
        margin-bottom:12px;
        box-shadow:0 6px 18px rgba(122,31,162,.22);
      }

      .zb-intro-name{
        font-size:22px;
        font-weight:800;
        margin-bottom:10px;
      }

      .zb-intro-text{
        font-size:14px;
        line-height:1.6;
        white-space:pre-wrap;
      }

      .zb-intro-disclaimer{
        margin-top:10px;
        font-size:12px;
        line-height:1.5;
        opacity:.92;
      }

      .zb-suggest-wrap{
        margin-top:14px;
      }

      .zb-suggest-title{
        font-size:13px;
        font-weight:700;
        color:#666;
        margin-bottom:10px;
      }

      .zb-suggest-list{
        display:flex;
        flex-direction:column;
        gap:8px;
      }

      .zb-suggest-btn{
        width:100%;
        text-align:left;
        border:none;
        border-radius:14px;
        padding:12px 14px;
        cursor:pointer;
        background:#f3f3f3;
        color:#111;
        font-size:13px;
        line-height:1.4;
      }

      .zb-suggest-btn:hover{
        background:#ebebeb;
      }

      @media (max-width: 480px){
        #zb-chat-wrap{
          right:12px;
          bottom:12px;
          left:auto;
        }

        #zb-chat-btn{
          margin-left:auto;
          display:block;
        }

        #zb-chat-box{
          width:calc(100vw - 24px);
          height:70vh;
        }
      }
    `;
    document.head.appendChild(style);

    const btn = document.getElementById("zb-chat-btn");
    const box = document.getElementById("zb-chat-box");
    const closeBtn = document.getElementById("zb-chat-close");
    const input = document.getElementById("zb-chat-input");
    const send = document.getElementById("zb-chat-send");
    const messages = document.getElementById("zb-chat-messages");

    let introRendered = false;

    function addMsg(text, role) {
      const div = document.createElement("div");
      div.className = `zb-msg ${role === "user" ? "zb-user" : "zb-ai"}`;
      div.textContent = text;
      messages.appendChild(div);
      messages.scrollTop = messages.scrollHeight;
      return div;
    }

    function renderIntro() {
      if (introRendered) return;
      introRendered = true;

      const intro = document.createElement("div");
      intro.className = "zb-intro-card";
      intro.innerHTML = `
        <div class="zb-intro-name">${GREETING_TITLE}</div>
        <div class="zb-intro-text">${GREETING_TEXT.replace(/\n/g, "<br>")}</div>
        <div class="zb-intro-disclaimer">${DISCLAIMER_TEXT}</div>
      `;
      messages.appendChild(intro);

      const suggestWrap = document.createElement("div");
      suggestWrap.className = "zb-suggest-wrap";
      suggestWrap.innerHTML = `
        <div class="zb-suggest-title">Suggested questions</div>
        <div class="zb-suggest-list"></div>
      `;
      messages.appendChild(suggestWrap);

      const list = suggestWrap.querySelector(".zb-suggest-list");

      SUGGESTED_QUESTIONS.forEach((question) => {
        const qBtn = document.createElement("button");
        qBtn.className = "zb-suggest-btn";
        qBtn.type = "button";
        qBtn.textContent = question;
        qBtn.addEventListener("click", () => {
          input.value = question;
          send.click();
        });
        list.appendChild(qBtn);
      });

      messages.scrollTop = messages.scrollHeight;
    }

    btn.addEventListener("click", () => {
      const isHidden = box.style.display === "none";
      box.style.display = isHidden ? "flex" : "none";
      if (isHidden) renderIntro();
    });

    closeBtn.addEventListener("click", () => {
      box.style.display = "none";
    });

    function parseSSEChunk(rawChunk, onToken) {
      const lines = rawChunk.split("\n");
      let done = false;

      for (const line of lines) {
        const trimmed = line.trim();
        if (!trimmed.startsWith("data:")) continue;

        const payload = trimmed.slice(5).trim();
        if (!payload) continue;
        if (payload === "[DONE]") {
          done = true;
          continue;
        }

        try {
          const chunk = JSON.parse(payload);
          const token =
            chunk?.choices?.[0]?.delta?.content ||
            chunk?.choices?.[0]?.message?.content ||
            chunk?.content ||
            "";

          if (token) onToken(token);
        } catch (e) {
          // ignore non-json keepalive
        }
      }

      return done;
    }

    async function askAI(message) {
      addMsg(message, "user");
      const aiMsg = addMsg("Thinking...", "ai");

      try {
        const response = await fetch(API_URL, {
          method: "POST",
          headers: {
            "Accept": "text/event-stream, application/json",
            "Content-Type": "application/json",
            "X-API-Key": API_KEY
          },
          body: JSON.stringify({
            model: "openrouter/auto",
            messages: [
              { role: "user", content: message }
            ],
            session_id: SESSION_ID,
            audience: "zenzoone",
            stream: true
          })
        });

        if (!response.ok) {
          aiMsg.textContent = `Request failed (${response.status})`;
          return;
        }

        const contentType = response.headers.get("content-type") || "";

        if (contentType.includes("application/json")) {
          const data = await response.json();
          const reply =
            data?.choices?.[0]?.message?.content ||
            data?.error?.message ||
            "Sorry, no response.";
          aiMsg.textContent = reply;
          return;
        }

        if (!response.body) {
          aiMsg.textContent = "Empty response body.";
          return;
        }

        aiMsg.textContent = "";
        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let buffer = "";

        while (true) {
          const { done, value } = await reader.read();
          buffer += decoder.decode(value || new Uint8Array(), { stream: !done });

          const chunks = buffer.split("\n\n");
          buffer = chunks.pop() || "";

          for (const chunk of chunks) {
            const streamDone = parseSSEChunk(chunk, (token) => {
              aiMsg.textContent += token;
              messages.scrollTop = messages.scrollHeight;
            });

            if (streamDone) return;
          }

          if (done) {
            if (buffer.trim()) {
              parseSSEChunk(buffer, (token) => {
                aiMsg.textContent += token;
                messages.scrollTop = messages.scrollHeight;
              });
            }
            return;
          }
        }
      } catch (err) {
        console.error(err);
        aiMsg.textContent = "Something went wrong. Please try again.";
      }
    }

    send.addEventListener("click", () => {
      const text = input.value.trim();
      if (!text) return;
      input.value = "";
      askAI(text);
    });

    input.addEventListener("keydown", (e) => {
      if (e.key === "Enter") send.click();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", createChatUI);
  } else {
    createChatUI();
  }
})();
